import "../index.css";
import { PencilIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { FormattedDate } from "@/components/columns/FormattedDate";
import { ImageGallery } from "@/components/ImageGallery";
import type { IInspectorLicense } from "@/types/users-inspectors";
import { Card, Heading, IconButton, LabelValue, Row, Tooltip } from "@/ui-kit";

type IProps = {
  license: IInspectorLicense;
  onEdit?: () => void;
};

export const LicenseDetailsCard = ({ license, onEdit }: IProps) => {
  const { t } = useTranslation();
  const labelWidth = "128px";

  return (
    <Card className="profile-card">
      <Card.Body>
        <Row gap="xl" alignmentVertical="top">
          <div className="profile-card__image-gallery">
            <ImageGallery
              imageUrls={[license.frontImageUrl, license.backImageUrl]}
            />
          </div>
          <div className="profile-card__details">
            <Row gap="sm">
              <Heading level={3} tone="default">
                {t("label.drivers_license")}
              </Heading>

              {onEdit && (
                <div className="profile-card__actions">
                  <Tooltip content={t("action.edit")} placement="bottom-end">
                    <IconButton
                      size="sm"
                      variant="ghost"
                      color="neutral"
                      content={<PencilIcon />}
                      onClick={onEdit}
                      aria-label={t("action.edit")}
                    />
                  </Tooltip>
                </div>
              )}
            </Row>

            <div className="profile-card__sections">
              <div className="profile-card__section">
                <LabelValue
                  label={t("label.license_number")}
                  value={license.documentNumber}
                  labelWidth={labelWidth}
                  canCopy
                />
                <LabelValue
                  label={t("label.issuance_date")}
                  value={<FormattedDate value={license.issuanceDate} />}
                  labelWidth={labelWidth}
                />
                <LabelValue
                  label={t("label.expiry_date")}
                  value={<FormattedDate value={license.expiryDate} />}
                  labelWidth={labelWidth}
                />
              </div>
            </div>
          </div>
        </Row>
      </Card.Body>
    </Card>
  );
};
